import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  private apiUrl: string;

  constructor(
    private _http: HttpClient,
  ) { 
    this.apiUrl = environment.apiUrl;
  }

  listarUsuarios(): Observable<any> {

    let url =  `${this.apiUrl}usuarios`;

    return this._http.get(url, { });

  }

  guardarUsuarios(data): Observable<any> {

    let myData = { 
      "name": data.name,
      "last_name": data.lastName,
      "number_document": data.numberDocument,
      "indicative": data.indicative,
      "phone": data.phone
    }

    let url = `${this.apiUrl}usuarios`;
   
    return this._http.post(url, myData);

  }

  eliminarUsuarios( idUsuario ) {
      let url = `${this.apiUrl}usuarios/usuario/${idUsuario}`;
    
      return this._http.delete(url, {});     
  }
}
